export class Leaderboard {
    constructor(selector) {
      this.leaderboardElement = document.querySelector(selector);
      if (this.leaderboardElement) {
        this.showMore();
      }
    }

    showMore() {
        document.addEventListener('DOMContentLoaded', function () {
            const showMoreButton = document.getElementById('show-more-leaderboard');
            if (!showMoreButton) {
                return;
            }

            showMoreButton.addEventListener('click', function (event) {
                event.preventDefault();
                const leaderboardItems = document.querySelectorAll('.leaderboard .result.hidden');
                leaderboardItems.forEach(function (item) {
                    item.classList.remove('hidden');
                });
                showMoreButton.classList.add('hidden');
            });
        });
    }

}

new Leaderboard('.leaderboard');
